import { render, staticRenderFns } from "./ChartRemessasAnual.vue?vue&type=template&id=0c9234ae"
import script from "./ChartRemessasAnual.vue?vue&type=script&lang=js"
export * from "./ChartRemessasAnual.vue?vue&type=script&lang=js"
import style0 from "./ChartRemessasAnual.vue?vue&type=style&index=0&id=0c9234ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports